//@ts-check
import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Hook that fetch the my_users_data
 * @function
 * @param {number} iteration
 * @returns {import('common/types/connections_types').UseFetchHookResponse<Array<TipoSalidaDto>>}
 */
const useFetchTipoSalida = (iteration = 0) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)
    axios
      .get('/tiposalida')
      .then((/**@type {import('axios').AxiosResponse<TipoSalidaDto>}*/ request_response) => {
        const data = request_response.data
        // @ts-ignore
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
  }, [iteration])

  // @ts-ignore
  return { response, error, loading }
}

export default useFetchTipoSalida
